import { render, staticRenderFns } from "./CodeVerificationSuccessModal.vue?vue&type=template&id=784c2d15&scoped=true"
import script from "./CodeVerificationSuccessModal.vue?vue&type=script&lang=js"
export * from "./CodeVerificationSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./CodeVerificationSuccessModal.vue?vue&type=style&index=0&id=784c2d15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c2d15",
  null
  
)

export default component.exports